/**
 *
 * @type {{id: number, overlay: null, modalPosition: Array, modals: {}}}
 */
export let modalDefaults = {
	id: 0,
	overlay: null,
	modalPosition: [],
	modals: {},
};
